var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-4 rich-text-block-wrapper"},[(_vm.parentFeature || _vm.parentlessCommentsEnabled)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.config.defaultContent)}}):_c('b-spinner',{attrs:{"small":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }